import { ArrowLeft01Icon } from '@hugeicons/react'
import clsx from 'clsx'

import { useAppRouter } from '@/shared/hooks/useAppRouter'
import { Button } from '@/shared/ui/Button'

type PageBackButtonProps = {
  /** `surface` — PageHeader (fundo claro). `immersive` — PageHero full (gradiente). */
  variant: 'surface' | 'immersive'
  className?: string
  /** Destino do voltar. Omitido = home (`/`). */
  backHref?: string
}

export const PageBackButton = ({
  variant,
  className,
  backHref
}: PageBackButtonProps) => {
  const router = useAppRouter()

  const handleBack = () => {
    router.push(backHref ?? '/')
  }

  const ariaLabel = backHref ? 'Voltar' : 'Voltar para o início'

  if (variant === 'immersive') {
    return (
      <button
        type="button"
        onClick={handleBack}
        aria-label={ariaLabel}
        className={clsx(
          'flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[10px]',
          'bg-white/20 text-white transition-colors hover:bg-white/30 active:bg-white/10',
          className
        )}
      >
        <ArrowLeft01Icon size={18} variant="stroke" />
      </button>
    )
  }

  return (
    <Button
      type="button"
      variant="light"
      icon
      onClick={handleBack}
      aria-label={ariaLabel}
      className={clsx(
        '!border !border-solid !border-contour hover:enabled:!border-gray-300',
        className
      )}
      leadingIcon={<ArrowLeft01Icon variant="stroke" />}
    />
  )
}
